export const CLIENT_TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'accountNumber', label: 'Número de Conta', alignRight: false },
  { id: 'accountType', label: 'Tipo de Conta', alignRight: false },
  { id: 'validateDate', label: 'Data de Validade', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];
